import { StyledModal } from '@app/components/modal/Modal';
import useAgentActions from '@app/hooks/agents/useAgentActions';
import { AgentForm } from './AgentForm';
import type { AIAgent } from '@app/services/agent.types';
import type { ModalProps } from 'antd';

export type AgentAddModalProps = ModalProps & {
    title?: string;
    data?: AIAgent;
};

export const AgentAddModal = ({
    title = 'Add AI Agent',
    data,
    onOk,
    ...props
}: AgentAddModalProps) => {
    const { addAgent } = useAgentActions();

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    return (
        <StyledModal title={title} footer={null} {...props}>
            <AgentForm
                id="ai-agent-add"
                data={data}
                onCancel={props.onCancel}
                loading={addAgent.isPending}
                onSubmit={(values) => {
                    const formData = {
                        ...values,
                    };
                    addAgent.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
